import { ResultData } from "../enums/index.js";

const defaultTS = new Date();

const resultPairsSorter = (pairA, pairB) => {
    const pairATS = (pairA.pitch !== null
        ? pairA.pitch[ResultData.CreateDate.key]
        : pairA.hit !== null
            ? pairA.hit[ResultData.CreateDate.key]
            : defaultTS
    );

    const pairBTS = (pairB.pitch !== null
        ? pairB.pitch[ResultData.CreateDate.key]
        : pairB.hit !== null
            ? pairB.hit[ResultData.CreateDate.key]
            : defaultTS
    );

    return Date.parse(pairATS) - Date.parse(pairBTS);
};

export default resultPairsSorter;